import React from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import { useDispatch } from 'react-redux'
import { verifyUserProfile } from '../../actions'

const useStyles = makeStyles(() => ({
  dialogRoot: {
    padding: '1rem 1rem 1.5rem 1rem',
    borderRadius: '2rem'
  },
  dialogTitle: {
    fontSize: '1.6rem !important',
    fontWeight: '400',
    textAlign: 'center',
    marginBottom: '-1rem'
  },
  dialogBigText: {
    fontSize: '2rem',
    textAlign: 'center',
    color: '#F67131',
    fontWeight: '500',
    lineHeight: '2.4rem',
    marginBottom: '2rem',
    marginTop: '-1rem'
  },
  dialogText: {
    fontSize: '1.4rem',
    textAlign: 'center',
    fontWeight: '400',
    lineHeight: '1.6rem',
    marginBottom: '2rem'
  },
  dialogSmallText: {
    fontSize: '1.2rem',
    textAlign: 'center',
    fontWeight: 300,
    marginBottom: '0rem'
  },
  button: {
    fontSize: '1.4rem',
    textAlign: 'right',
    fontWeight: 500,
    backgroundColor: '#F67131',
    color: '#FFFFFF',
    borderRadius: '5rem',
    padding: '.6rem 1.6rem',
    '&:hover': {
      backgroundColor: '#ff4da6'
    },
    boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)'
  },
  closeButton: {
    color: '#1E1E1E',
    position: 'absolute',
    right: '1.5rem',
    top: '0rem',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  iconButton: {
    fontSize: '2.4rem'
  }
}))

const VerificationAlertDialog = ({ open, close, saveInvoice }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()

  const doVerification = () => {
    saveInvoice()
    dispatch(verifyUserProfile())
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={close}
        aria-describedby="alert-dialog-description"
        classes={{ paper: classes.dialogRoot }}
        maxWidth="sm"
      >
        <DialogTitle>
          <IconButton
            edge="end"
            className={classes.closeButton}
            onClick={close}
            aria-label="close"
          >
            <CloseIcon className={classes.iconButton} />
          </IconButton>
          <Typography className={classes.dialogTitle}>
            {t('invoice.verificationAttention')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography className={classes.dialogBigText}>
              {t('invoice.verificationAlert')}
            </Typography>
            <Typography className={classes.dialogText}>
              {t('invoice.verificationInstructions')}
            </Typography>
            <Typography className={classes.dialogSmallText}>
              {t('invoice.verificationNote')}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className={classes.button} onClick={doVerification}>
            {t('invoice.verificationButton')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default VerificationAlertDialog
